import { getAuth } from "firebase/auth";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import addLogDocument from "./addLogDocument";
import { auth, dbCentral } from "../config/FirebaseConfig";

// Function to send error message to Discord
const sendErrorDiscord = async (message, prefix) => {
  // Define the endpoint URL
  const url = prefix + "send/react-error";

  // Define the request body
  const body = {
    message: message,
  };

  const headers = {
    "Content-Type": "application/json",
  };

  try {
    // Make the POST request
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(body),
    });

    const currentUser = auth.currentUser;

    if (!currentUser) {
      return;
    }

    const db = getFirestore();
    const userRef = doc(dbCentral, "user", currentUser.uid);

    // Retrieve the organization reference from the user document
    const userSnapshot = await getDoc(userRef);

    if (!userSnapshot.exists()) {
      console.error("User document not found");
      return;
    }

    const orgId = userSnapshot.get("org_id");

    // Add log document (Assuming you have a similar function for adding logs in JavaScript)
    await addLogDocument(
      url,
      prefix,
      userRef.id,
      orgId,
      response.status.toString(),
      "",
      "",
      JSON.stringify(body), // Log the request body
      await response.text() // Log the response body as text
    );

    // Check if the request was successful
    if (response.ok) {
    } else {
      console.error(`Failed to send error: ${response.status}`);
    }
  } catch (error) {
    // Handle exceptions
    console.error(`Exception occurred: ${error.message}`);
  }
};

export default sendErrorDiscord;
